import { cn } from "@/lib/utils";
import { LoadingSkeleton } from "./LoadingSkeleton";

export const MetricCard = ({
  label,
  value,
  unit,
  supportingText,
  trend,
  icon: Icon,
  tooltip,
  loading = false,
  missing = false,
  accent,
  soft,
  testId,
  className,
}) => {
  if (loading) {
    return (
      <div className={cn("metric-card", className)} data-testid={testId}>
        <LoadingSkeleton className="h-3 w-24 mb-3" />
        <LoadingSkeleton className="h-8 w-32" />
      </div>
    );
  }

  const displayValue = missing || value == null || value === "" ? "—" : value;

  return (
    <div
      className={cn("metric-card", className)}
      data-testid={testId}
      style={accent ? { borderLeft: `3px solid ${accent}` } : undefined}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="card-label">
          {label}
        </div>
        {Icon ? (
          <div
            className="icon-frame w-8 h-8"
            style={
              accent
                ? { color: accent, background: soft || undefined, borderColor: `${accent}55` }
                : undefined
            }
          >
            <Icon className="w-4 h-4" strokeWidth={1.75} aria-hidden="true" />
          </div>
        ) : null}
      </div>
      <div className="metric-value mt-3 min-w-0 text-[1.125rem] leading-tight sm:text-[1.75rem] sm:leading-[1.15]">
        <span className="whitespace-nowrap">
          {displayValue}
          {unit && displayValue !== "—" ? (
            <span className="metric-unit">{unit}</span>
          ) : null}
        </span>
      </div>
      {supportingText ? (
        <p className="meta-text mt-2 leading-relaxed">{supportingText}</p>
      ) : null}
      {missing ? (
        <p className="text-xs text-dark-text-muted mt-2">Unavailable for this period.</p>
      ) : null}
      {tooltip ? (
        <p className="sr-only">{tooltip}</p>
      ) : null}
      {trend ? <div className="mt-3">{trend}</div> : null}
    </div>
  );
};
